import { Injectable } from '@angular/core';
import * as _ from 'lodash';

const UAParser = require('ua-parser-js/dist/ua-parser.min'); // eslint-disable-line import/no-internal-modules

@Injectable()
export class BrowserSupportService {

  private _supportedBrowsersByCmsLib = ['Chrome', 'Chrome Headless'];
  private _supportedBrowsersByAssistedBrowsing = ['Chrome', 'Chrome Headless', 'Firefox', 'Safari', 'Edge'];
  private _uaParser;

  constructor() {
    this._uaParser = new UAParser();
  }

  set uaParser(UaParser) {
    this._uaParser = UaParser;
  }

  /**
   * CMSLib is a LMI extension over WebRtc. Remote Control related features are based on this library.
   * This method tells if the user's current browser is supported.
   * */
  public isCmsLibSupportedByCurrentBrowser() {
    return _.includes(this._supportedBrowsersByCmsLib, this._uaParser.getBrowser().name);
  }

  /**
   * Assisted Browsing (Co-browse) feature is only allowed on browsers with CSP support because of security reasons
   * This method tells if the user's current browser is supported.
   * */
  public isAssistedBrowsingSupportedByCurrentBrowser() {
    return _.includes(this._supportedBrowsersByAssistedBrowsing, this._uaParser.getBrowser().name);
  }

}
